import { createStore } from 'redux'
import { ApiGet } from 'src/api/api'

const initialState = {
  sidebarShow: 'responsive',
  agents: [],
  tickets: []
}

const changeState = (state = initialState, { type, ...rest }) => {
  switch (type) {
    case 'set':
      return { ...state, ...rest }
    default:
      return state
  }
}

const store = createStore(changeState)
export default store
